<template>
  <LandingHeader>
    <div class="service-page">
      <ServicePageHeader
        :icon="icon"
        :title="title"
        :subtitle="subtitle"
        :show-back-link="showBackLink"
      />

      <main class="service-content">
        <div class="container">
          <slot />
        </div>
      </main>
    </div>
  </LandingHeader>
</template>

<script>
import LandingHeader from '@/components/landing/LandingHeader.vue'
import ServicePageHeader from '@/components/landing/ServicePageHeader.vue'
import '@/assets/css/landing/pages/services.css'

export default {
  name: 'ServicePageLayout',

  components: {
    LandingHeader,
    ServicePageHeader
  },

  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    showBackLink: {
      type: Boolean,
      default: false
    }
  }
}
</script>
